export default __webpack_public_path__ + "static/media/cpp.ef391487.webp";